import { BrandAnalysisComponent } from "src/app/modules/brand-analysis/brand-analysis/brand-analysis.component";

export const COMMON_CONSTANTS = {
  NestingConfiguration: 2,
  InsufficientBase_Sample: 15,
  LowBase_Sample: 30,
  SigLowerLimit_95: -1.96,
  SigUpperLimit_95: 1.96,
  SigLowerLimit_90: -1.65,
  SigUpperLimit_90: 1.65,
  SigLowerLimit_98: -2.33,
  SigUpperLimit_98: 2.33,
  BrandAnalysisModuleId: 6,
  Configuration: 998,
  SnapshotModuleId: 2,
  DataExplorerModuleId: 1,
  DataUploadModuleId: "Data Upload",
  CrossTabModuleId: "Crosstab",
  BrandAnalysisModuleNameId: "Brand Analysis",

  //ModuleNames
  DataUploadModuleName: "Data Upload",
  CrossTabModuleName: "Crosstab",
  BrandAnalysisModuleName: "Brand Analysis",
  ARKName: "ARK",
  SnapShotModuleName: "Snapshot",
  DataUploadName: "Data Upload",
  AlertName: "Alert",


  powerBIurl:
    'https://app.powerbi.com/reportEmbed?reportId=fe44bd33-c58e-4b4e-83fc-45ffaaf97f3f&appId=e4d78180-0859-4013-96fc-3d87815368b8&autoAuth=true&ctid=1e355c04-e0a4-42ed-8e2d-7351591f0ef1&filterPaneEnabled=false&navContentPaneEnabled=false',
};

export const COMMON_CONSTANTS_SETTING = {
UserManagement: "userManagement",
ProjectManagement: "projectManagement",
DataUpload: "dataUpload",
ExportDownload: "exportDownload",
HelpGuide: "helpGuide",
SnapshotViews: "snapshotViews",
ReportIssue: "reportIssue",
Logout: "logout",
DocumentRepository: "documentRepository"
}

export const COMMON_CONSTANTS_SNAPSHOT = {
  NestingConfiguration: 2,
  InsufficientBase_Sample: 15,
  LowBase_Sample: 30,
  SigLowerLimit_95: -1.96,
  SigUpperLimit_95: 1.96,
  SigLowerLimit_90: -1.65,
  SigUpperLimit_90: 1.65,
  SigLowerLimit_98: -2.33,
  SigUpperLimit_98: 2.33,
  SigUpperLimit_None: 0,
  SigLowerLimit_None: 0,
  BrandAnalysisModuleId: 6,
  Configuration: 998,
  SnapshotModuleId: 2,
  DataExplorerModuleId: 1,
  powerBIurl:
    'https://app.powerbi.com/reportEmbed?reportId=fe44bd33-c58e-4b4e-83fc-45ffaaf97f3f&appId=e4d78180-0859-4013-96fc-3d87815368b8&autoAuth=true&ctid=1e355c04-e0a4-42ed-8e2d-7351591f0ef1&filterPaneEnabled=false&navContentPaneEnabled=false',
};
export const COMMON_CONSTANTS_Percentage = {
  ConfidencePercent_90: '90%',
  ConfidencePercent_95: '95%',
  ConfidencePercent_98: '98%',
  ConfidencePercent_None: 'None'

};
export interface UserRoleItem {
  value: number;
  label: string;
}
export const USER_ROLE_ITEMS: ReadonlyArray<UserRoleItem> = Object.freeze([
  { value: 1, label: 'Super Admin' },
  { value: 2, label: 'Business User' },
  { value: 3, label: 'GDC Admin' },
]);
export const BUTTON_HOVER_NAMES = {
  Filtering: `User can see shares on selected Total, the metric in 'Rows' are FILTERED on the metrics selected in 'Row Nesting'.`,
  Profiling: `This allows user to see shares of Nested groups on Parent Metric. Here, Metrics selected in 'Rows' are PROFILED by the metrics selected in 'Row Nesting'.`,
  Answer_Base: `All the Metrics selected in the Filters and Columns along with an additional filter of Respondents who have answered that particular question(in Row) constitutes the base`,
  Total_Base: `All the Metrics selected in the Filters and Columns constitute the base`,
  Load_Selection: `Auto generate saved selection`,
  Custom_Groups: `Define new metrics using existing variables`,
  Custom_Report: `Combine saved selections into a report`

}

export interface CheckboxSelection {
  id: number;
  selected: boolean;
  name: string;
  value: string;
}

export class CheckboxSelectionModel {
  static additionalCheckBoxSelection: CheckboxSelection[] = [
    { id: 1, selected: false, name: 'Ranking', value: 'Ranking' },
    { id: 2, selected: false, name: 'Sticky Selection', value: 'Sticky_Selection' },
    { id: 3, selected: false, name: 'Help Guide', value: 'Help_Guide' },
    { id: 4, selected: false, name: 'Static Time Frame', value: 'Static_Time_Frame' },
    { id: 5, selected: false, name: 'AI Integration', value: 'AI_Integration' },
    { id: 6, selected: false, name: 'Entry points _ Multi Select', value: 'Entry_points_Multi_Select' },
  ];

}

export const exceptionMessage =
  `This dashboard/module is specifically designed to support **{{client}}** - **{{study}}** and its predefined parameters.<br>` +
  `It does not support general knowledge queries or incomplete requests that fall outside the scope.<br>` +
  `Please **rephrase your query** to align with the available parameters and features of the **{{client}}** - **{{study}}** for relevant results.`;


